module.exports = __webpack_public_path__ + "static/img/score.65ed0b57.jpg";